'use strict';

class AccountTabs {
  constructor(userService) {
    this.userService = userService;
  }

  $onInit() {
    this.links = [];
    this.activeTab = null;

    this.load();
  }

  load() {
    this.userService.get()
      .then((resp) => resp.data.features)
      .then((features) => {
        this.links = [{
          id: 'basic',
          url: 'konto',
          name: 'Konto',
          icon: 'user',
          visible: true
        }, {
          id: 'settings',
          url: 'konto/innstillinger',
          name: 'Innstillinger',
          icon: 'cog',
          visible: true
        }, {
          id: 'integrations',
          url: 'konto/integrasjoner',
          name: 'Tilleggstjenester',
          icon: 'cloud',
          visible: true
        }, {
          id: 'users',
          url: 'konto/tilgang',
          name: 'Tilgang',
          icon: 'user-plus',
          visible: true
        }, {
          id: 'accounting',
          url: 'konto/regnskap',
          name: 'Regnskap',
          icon: 'book',
          visible: features.indexOf('GENERAL_LEDGER') !== -1
        }];
      });
  }
}

AccountTabs.$inject = ['userService'];

const accountTabs = {
  bindings: {
    activeTab: '@'
  },
  controller: AccountTabs,
  template: `
    <p>
      <a ng-if="link.visible" ng-repeat="link in $ctrl.links" class="tab-button" ng-class="{ active: $ctrl.activeTab == link.id }" ng-href="#/{{ link.url }}">
        <i class="fa fa-{{ link.icon }}"></i> {{ link.name }}
      </a>
    </p>
  `
};

angular
  .module('SendRegning')
  .component('accountTabs', accountTabs);
